import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCompare } from '../context/CompareContext';

const CompareFloatingButton = () => {
    const { comparedProducts } = useCompare();
    const navigate = useNavigate();

    if (!comparedProducts || comparedProducts.length === 0) {
        return null;
    }

    const count = comparedProducts.length;

    const handleCompareClick = (e) => {
        // Guarantee immediate navigation on both touch and mouse clicks
        e.preventDefault();
        e.stopPropagation();
        navigate('/compare');
    };

    return (
        <>
            <style>{`
                .glb-compare-floating-fab {
                    position: fixed;
                    bottom: 35px;
                    right: 102px;
                    width: 52px;
                    height: 52px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.92);
                    backdrop-filter: blur(20px) saturate(180%);
                    -webkit-backdrop-filter: blur(20px) saturate(180%);
                    border: 1.5px solid rgba(255, 255, 255, 0.95);
                    color: #ea8e46;
                    text-decoration: none;
                    z-index: 10000 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-sizing: border-box;
                    box-shadow: 0 8px 22px -4px rgba(0, 75, 100, 0.15), 0 2px 8px rgba(234, 142, 70, 0.15), inset 0 1px 1.5px rgba(255, 255, 255, 1);
                    cursor: pointer;
                    touch-action: manipulation;
                    -webkit-tap-highlight-color: transparent;
                    pointer-events: auto !important;
                    user-select: none;
                    transition: transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.25s ease, border-color 0.25s ease, color 0.25s ease;
                }
                .glb-compare-floating-fab:hover {
                    transform: translateY(-3px) scale(1.06);
                    border-color: #ea8e46;
                    color: #f7931e;
                    background: #ffffff;
                    box-shadow: 0 12px 28px -4px rgba(0, 125, 165, 0.22), 0 0 14px rgba(234, 142, 70, 0.3), inset 0 1px 2px #ffffff;
                }
                .glb-compare-floating-fab:active {
                    transform: scale(0.95);
                }
                .glb-compare-floating-fab svg {
                    width: 23px;
                    height: 23px;
                    fill: currentColor;
                    pointer-events: none;
                    transition: transform 0.25s ease;
                }
                .glb-compare-fab-badge {
                    position: absolute;
                    top: -3px;
                    right: -3px;
                    background: linear-gradient(135deg, #f58e42 0%, #ea8335 100%);
                    color: #ffffff;
                    min-width: 20px;
                    height: 20px;
                    border-radius: 10px;
                    font-size: 11px;
                    font-weight: 800;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 4px;
                    line-height: 1;
                    box-sizing: border-box;
                    border: 2px solid #ffffff;
                    pointer-events: none;
                    box-shadow: 0 2px 6px rgba(234, 142, 70, 0.45), 0 1px 3px rgba(0, 0, 0, 0.12);
                    animation: glbBadgePop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }
                @keyframes glbBadgePop {
                    0% { transform: scale(0.5); }
                    60% { transform: scale(1.2); }
                    100% { transform: scale(1); }
                }

                @media (max-width: 480px) {
                    .glb-compare-floating-fab {
                        bottom: 14px;
                        right: 66px;
                        width: 42px;
                        height: 42px;
                        box-shadow: 0 6px 16px -2px rgba(0, 75, 100, 0.14), 0 2px 6px rgba(234, 142, 70, 0.12);
                    }
                    .glb-compare-floating-fab svg {
                        width: 18px;
                        height: 18px;
                    }
                    .glb-compare-fab-badge {
                        top: -3px;
                        right: -3px;
                        min-width: 18px;
                        height: 18px;
                        font-size: 10px;
                        padding: 0 3px;
                    }
                }
            `}</style>
            <Link
                to="/compare"
                onClick={handleCompareClick}
                className="glb-compare-floating-fab"
                aria-label={`Krahaso ${count} produkte`}
                title={`Krahaso (${count} produkte)`}
            >
                <svg
                    viewBox="0 0 122.88 102.72"
                    fill="currentColor"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M65.61,20.91v72.74h35.63c0.38,0,0.68,0.31,0.68,0.69v7.7c0,0.38-0.31,0.69-0.68,0.69H22.84c-0.38,0-0.69-0.31-0.69-0.69v-7.7c0-0.38,0.31-0.69,0.69-0.69h35.63l0-72.71c-3.1-1.08-5.56-3.53-6.64-6.63H29.3v3.43c0,0.38-0.31,0.68-0.68,0.68h-5.78c-0.38,0-0.69-0.31-0.69-0.68v-3.43h-5.73c-0.44,0-0.8-0.31-0.8-0.68V7.84c0-0.38,0.36-0.69,0.8-0.69h35.43C53.33,2.99,57.31,0,61.99,0c4.68,0,8.66,2.99,10.14,7.16h35.53c0.44,0,0.8,0.31,0.8,0.69v5.78c0,0.38-0.36,0.68-0.8,0.68h-6.46v3.43c0,0.38-0.31,0.68-0.68,0.68h-5.78c-0.38,0-0.69-0.31-0.69-0.68v-3.43H72.16C71.09,17.38,68.67,19.81,65.61,20.91ZM99.66,22.3l22.91,40.48c0.2,0.35,0.29,0.73,0.28,1.1h0.02v0.15c0,9.64-11.35,17.46-25.35,17.46c-13.85,0-25.1-7.65-25.34-17.15c-0.04-0.16-0.06-0.34-0.06-0.51c0-0.44,0.14-0.86,0.37-1.2L95.92,22.2c0.59-1.02,1.89-1.37,2.91-0.78C99.2,21.65,99.48,21.95,99.66,22.3ZM99.75,31.11v30.6h17.32L99.75,31.11ZM95.67,61.7V31.16L77.96,61.7H95.67ZM27.54,22.3l22.91,40.48c0.2,0.35,0.29,0.73,0.28,1.1h0.02v0.15c0,9.64-11.35,17.46-25.35,17.46c-13.85,0-25.1-7.65-25.34-17.15C0.02,64.19,0,64.02,0,63.84c0-0.44,0.14-0.86,0.37-1.2L23.8,22.21c0.59-1.02,1.89-1.37,2.91-0.78C27.08,21.65,27.36,21.95,27.54,22.3ZM27.63,31.11v30.6h17.32L27.63,31.11ZM23.54,61.7V31.16L5.84,61.7H23.54ZM61.99,6.07c2.59,0,4.69,2.1,4.69,4.69c0,2.59-2.1,4.69-4.69,4.69c-2.59,0-4.69-2.1-4.69-4.69C57.3,8.17,59.4,6.07,61.99,6.07Z"
                    />
                </svg>
                <span className="glb-compare-fab-badge">{count}</span>
            </Link>
        </>
    );
};

export default CompareFloatingButton;
